import React from 'react'

const Title = ({ title }) => {
  return (
    <span className='text-cyan-800 font-bold font-poppins text-2xl md:text-[23px]'>{title}</span>
  )
}

export default Title